import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateClient } from '../../services/clientService';

const STAGES = [
  { key: 'novo', titulo: 'Novo Lead', cor: '#3B82F6' },
  { key: 'simulacao', titulo: 'Simulação Enviada', cor: '#8B5CF6' },
  { key: 'analise', titulo: 'Em Análise', cor: '#F5A623' },
  { key: 'fechado', titulo: 'Contrato Fechado', cor: 'var(--accent)' },
  { key: 'perdido', titulo: 'Perdido', cor: '#F43F5E' },
];

const AVATAR_COLORS = ['#3B82F6', '#8B5CF6', '#14B8A6', '#F43F5E', '#F97316', '#EC4899', '#6366F1', '#0EA5E9'];

function getColor(name) {
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getIniciais(name) {
  return (name || 'U').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
}

function formatDate(timestamp) {
  if (!timestamp) return '';
  const d = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });
}

function DealCard({ client, onEdit, onSimular, onDragStart }) {
  const cor = getColor(client.nome);
  const iniciais = getIniciais(client.nome);
  const bancos = client.bancos || [];
  const melhor = client.melhorBanco;
  const simCount = client.simulacoes || 0;

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, client.id)}
      style={{
        background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
        padding: 14, cursor: 'grab', transition: 'all 0.2s', userSelect: 'none',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{
            width: 28, height: 28, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '0.6rem', fontWeight: 700, color: '#fff', background: cor, flexShrink: 0,
          }}>{iniciais}</div>
          <span style={{ fontSize: '0.82rem', fontWeight: 600 }}>{client.nome}</span>
        </div>
        <span style={{ fontSize: '0.62rem', color: 'var(--text-muted)' }}>{formatDate(client.criadoEm)}</span>
      </div>

      {client.valorFinanciado && (
        <div style={{ fontSize: '1.1rem', fontWeight: 700, letterSpacing: '-0.01em', marginBottom: 2 }}>
          {client.valorFinanciado}
        </div>
      )}

      {client.email && (
        <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginBottom: 10 }}>{client.email}</div>
      )}

      {bancos.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
          {bancos.map((b) => (
            <span key={b.nome} style={{
              fontSize: '0.6rem', fontWeight: 600, padding: '3px 7px', borderRadius: 4,
              color: '#fff', background: b.cor || '#666',
            }}>{b.nome}</span>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: 10, borderTop: '1px solid var(--border)' }}>
        {melhor ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.68rem', fontWeight: 600 }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: melhor.cor || 'var(--accent)' }} />
            Melhor: {melhor.nome}
          </div>
        ) : (
          <div style={{ fontSize: '0.62rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 3 }}>
            ⚡ {simCount} simulaç{simCount === 1 ? 'ão' : 'ões'}
          </div>
        )}
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={() => onEdit && onEdit(client)} title="Editar" style={{
            width: 26, height: 26, borderRadius: 5, border: '1px solid var(--border)',
            background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '0.7rem', cursor: 'pointer',
          }}>✏️</button>
          <button onClick={() => onSimular && onSimular(client)} title="Simular" style={{
            width: 26, height: 26, borderRadius: 5, border: '1px solid var(--border)',
            background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '0.7rem', cursor: 'pointer',
          }}>⚡</button>
          <button
            onClick={() => {
              if (client.telefone) {
                const num = client.telefone.replace(/\D/g, '');
                window.open(`https://wa.me/55${num}`, '_blank');
              }
            }}
            title="WhatsApp" style={{
              width: 26, height: 26, borderRadius: 5, border: '1px solid var(--border)',
              background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '0.7rem', cursor: 'pointer',
            }}>💬</button>
        </div>
      </div>
    </div>
  );
}

export default function PipelineView({ clients, onEdit }) {
  const navigate = useNavigate();
  const [dragOverStage, setDragOverStage] = useState(null);
  const [draggingId, setDraggingId] = useState(null);

  const handleSimular = (client) => {
    navigate('/simulador', { state: { clienteId: client.id } });
  };

  const handleDragStart = (e, clientId) => {
    e.dataTransfer.setData('text/plain', clientId);
    e.dataTransfer.effectAllowed = 'move';
    setDraggingId(clientId);
  };

  const handleDragOver = (e, stageKey) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOverStage(stageKey);
  };

  const handleDragLeave = () => {
    setDragOverStage(null);
  };

  const handleDrop = async (e, stageKey) => {
    e.preventDefault();
    setDragOverStage(null);
    setDraggingId(null);
    const clientId = e.dataTransfer.getData('text/plain');
    if (!clientId) return;

    const client = (clients || []).find((c) => c.id === clientId);
    if (!client || client.stage === stageKey) return;

    try {
      await updateClient(clientId, { stage: stageKey });
    } catch (err) {
      console.error('Erro ao mover cliente:', err);
    }
  };

  const handleDragEnd = () => {
    setDragOverStage(null);
    setDraggingId(null);
  };

  const grouped = {};
  STAGES.forEach((s) => { grouped[s.key] = []; });
  (clients || []).forEach((c) => {
    const stage = c.stage || 'novo';
    if (grouped[stage]) grouped[stage].push(c);
    else grouped['novo'].push(c);
  });

  return (
    <div style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 16 }}>
      {STAGES.map((col) => {
        const deals = grouped[col.key];
        const isOver = dragOverStage === col.key;
        const totalVolume = deals.reduce((sum, c) => {
          const raw = String(c.valorFinanciado || '0').replace(/[^\d,]/g, '').replace(',', '.');
          return sum + (parseFloat(raw) || 0);
        }, 0);
        const formattedTotal = totalVolume > 0
          ? totalVolume.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })
          : '';
        return (
          <div key={col.key} style={{ minWidth: 280, width: 280, flexShrink: 0, display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 14px', background: 'var(--white)', border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm) var(--radius-sm) 0 0', borderBottom: `2.5px solid ${col.cor}`,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', fontWeight: 700 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: col.cor }} />
                {col.titulo}
                <span style={{
                  fontSize: '0.68rem', fontWeight: 600, padding: '2px 8px', borderRadius: 100,
                  background: 'var(--surface)', color: 'var(--text-muted)',
                }}>{deals.length}</span>
              </div>
              {formattedTotal && (
                <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
                  {formattedTotal}
                </span>
              )}
            </div>

            {/* Body — drop zone */}
            <div
              onDragOver={(e) => handleDragOver(e, col.key)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, col.key)}
              onDragEnd={handleDragEnd}
              style={{
                flex: 1,
                background: isOver ? `${col.cor}11` : 'rgba(247,248,250,0.6)',
                border: isOver ? `2px dashed ${col.cor}` : '1px solid var(--border)',
                borderTop: 'none',
                borderRadius: '0 0 var(--radius-sm) var(--radius-sm)',
                padding: 10,
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                minHeight: 200,
                transition: 'all 0.2s',
              }}
            >
              {deals.length === 0 && (
                <div style={{
                  fontSize: '0.72rem', color: isOver ? col.cor : 'var(--text-muted)',
                  textAlign: 'center', padding: 20, fontWeight: isOver ? 600 : 400,
                }}>
                  {isOver ? 'Soltar aqui' : 'Nenhum cliente'}
                </div>
              )}
              {deals.map((client) => (
                <div
                  key={client.id}
                  style={{
                    opacity: draggingId === client.id ? 0.4 : 1,
                    transition: 'opacity 0.15s',
                  }}
                >
                  <DealCard
                    client={client}
                    onEdit={onEdit}
                    onSimular={handleSimular}
                    onDragStart={handleDragStart}
                  />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}